import { client } from "utils/axios"
import * as yup from "yup";
import { showMessage } from "store/modules/Message";

export async function deleteIncidentType(incidentTypeId) {
    await client.delete(`incidentType/${incidentTypeId}`);
};
export async function getAllIncidentType() {
    const { data } = await client.get("/incidentType");
    return data;
}

export const validationSchemaIncidentType = yup.object({
    name: yup
        .string("Ingresa nombre de IncidentType")
        .required("Campo Requerido"),
    code: yup
        .string("Ingresa Codigo")
        .required("Campo Requerido"),

});
export const createIncidentType = async (incidentType, dispatch) => {
    try {

        const { data } = await client.post("incidentType", incidentType);
        dispatch(
            showMessage({
                message: "Posicion agregada con éxito",
                variant: "success",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "center",
                },
            })
        );

    } catch (error) {
        dispatch(
            showMessage({
                message:
                    "Ocurrió un error al agregar un posicion. ",
                variant: "error",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "center",
                },
            })
        );
    }
};

export const modifyIncidentType = async (incidentType, dispatch) => {
    try {

        await client.put("incidentType", incidentType);

        dispatch(
            showMessage({
                message: `Posicion "${incidentType.name}" modificada con éxito`,
                variant: "success",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
            })
        );
    } catch (error) {
        dispatch(
            showMessage({
                message:
                    `Ocurrió un error al modificar la posicion "${incidentType.name}"`,
                variant: "error",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
            })
        );
    }

};
